// Importing Foundation first
// ### Core
import $ from 'jquery';
import './global/foundation';
import 'what-input';

// Load foundation with Drupal BigPipe Support
(function ($, Drupal) {
  Drupal.behaviors.LoadFoundation = {
    attach: function (context, settings) {
      $(context).foundation();
    },
  };
})(jQuery, Drupal);

// Import all your components here
// But don't code inside this file.
// import './utils/polyfills'; // Only if supporting IE & Edge 15
import './utils/videos';
import './utils/tables';
import './utils/youtubeIframe';

// Components
import './components/fixedHeader';
import './components/mobileMenu';
import './components/smoothScroll';
import './components/swiper';
import './components/servicePanel';
import './components/searchBar';
import './components/drimage';
import './components/flightsWidget';
import './components/datepicker';
import './components/pill';
import './components/resatravel';

// Enables HMR for JS files imported here
if (module.hot) {
  module.hot.accept();
}
